import '../workspace-members-tab/MembersList.less'

import { ButtonClean } from 'front-end/src/components'
import EditorQuill from 'front-end/src/components/common/quill/EditorQuill'
import { debounce } from 'lodash'
import React, { FC, useCallback, useEffect, useState } from 'react'

import Quill from '@capaj/quill'
import { Flex } from '@chakra-ui/react'
import { t, Trans } from '@lingui/macro'
import ImageResize from '@looop/quill-image-resize-module-react'
import ImageUploader from '@looop/quill-image-uploader'

import { LooopS3FileUpload } from '../../../app/util/LooopS3FileUpload'
import { notification } from '../../../components/common/notifications/Notifications'
import Spinner from '../../../components/common/spinner/Spinner'
import { LooopS3BucketEnum } from '../../../graphql/private/PrivateSchemaTypes'
import ImageFormat from '../../topic-detail-page/components/text-element/ImageFormat'
import { replaceBase64ImagesInHtml } from '../../topic-detail-page/components/utils'
import {
  usePatchWorkspaceMutation,
  useWorkspaceDescriptionQuery
} from './WorkspaceDescriptionTab.codegen'

Quill.register(ImageFormat, true)
Quill.register('modules/imageUploader', ImageUploader)
Quill.register('modules/imageResize', ImageResize)

export const WorkspaceDescriptionTab: FC<{
  workspaceId: number
}> = ({ workspaceId }) => {
  const [description, setDescription] = useState('')

  const [patchDescription, { loading: isSaving }] = usePatchWorkspaceMutation()
  const {
    data,
    loading,
    refetch: refetchWorkspaceDescription
  } = useWorkspaceDescriptionQuery({
    variables: {
      workspaceId
    }
  })

  useEffect(() => {
    setDescription(data?.workspace?.description || '')
  }, [data])

  const updateDescription = useCallback(
    debounce(async (htmlContent) => {
      const { errors } = await patchDescription({
        variables: {
          workspaceId: workspaceId,
          patchInput: {
            description: htmlContent
          }
        }
      })

      if (errors) {
        notification.error(
          t`Description couldn't be updated. Please try again.`
        )
        refetchWorkspaceDescription()
      }
    }, 500),
    []
  )

  if (
    (!data && loading) ||
    data?.workspace?.__typename !== 'WorkspaceModelAsCoordinator'
  ) {
    return null
  }

  return (
    <Flex p="0 16px" flexDirection="column">
      <Flex
        justifyContent="space-between"
        alignItems="center"
        marginBottom="8px"
      >
        <h3>
          <Trans>Description</Trans>
        </h3>
        <ButtonClean isDisabled>
          {isSaving ? (
            <Flex flexDirection="row">
              <Spinner /> <Trans>Saving</Trans>
            </Flex>
          ) : (
            t`Saved`
          )}
        </ButtonClean>
      </Flex>
      <EditorQuill
        value={description}
        autofocus={true}
        uploadFn={async (fileName, blob) => {
          return LooopS3FileUpload({
            S3UploadProps: {
              filename: fileName,
              S3path: `workspace-description-images/workspace-${workspaceId}`,
              bucket: LooopS3BucketEnum.PRIVATE
            },
            blob: blob
          })
        }}
        onChange={async (content) => {
          const html = await replaceBase64ImagesInHtml(
            content,
            {
              S3path: `workspace-description-images/workspace-${workspaceId}`,
              bucket: LooopS3BucketEnum.PRIVATE
            },
            () => {}
          )

          setDescription(html)
          updateDescription(html)
        }}
      />
    </Flex>
  )
}
